/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN COURSE INSTRUCTOR API
 * Role: Admin
 * Scope: Tenant-based Course Instructor Dropdown
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

/* =============================================================
   BASE ENDPOINT
============================================================= */

const ADMIN_COURSE_INSTRUCTOR_ENDPOINT =
  "/admin/courses/courseInstructor.php";

/* =============================================================
   GET – Fetch Course Instructors
   Supports:
   - All Instructors
   - Course-wise Instructors (optional)
============================================================= */

export const getAdminCourseInstructors = async (
  { course_id = null } = {},
  options = {}
) => {
  try {

    const endpoint = course_id
      ? `${ADMIN_COURSE_INSTRUCTOR_ENDPOINT}?course_id=${course_id}`
      : ADMIN_COURSE_INSTRUCTOR_ENDPOINT;

    const res = await apiCall(
      "GET",
      endpoint,
      null,
      "Admin - Fetch Course Instructors",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message ||
          "Failed to fetch course instructors",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data || [],
    };

  } catch (error) {

    console.error(
      "Admin Fetch Course Instructors Error:",
      error
    );

    return {
      success: false,
      message:
        error.message ||
        "Unexpected error occurred",
      data: [],
    };

  }
};